import { FC } from "react"
import { TravelersList } from "../../../../module/travelers/containers/list"

export const TravelersListUserSearchPage: FC = () => <TravelersList />
